import React, { ComponentProps } from 'react';
import {
  DatePickerContainer,
  DatePickerInput,
  DatePickerLabel,
} from './DatePicker.styles';

export type DatePickerProps = ComponentProps<typeof DatePickerInput> & {
  label?: string;
  width?: string;
  error?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const DatePicker = ({ label, width, ...props }: DatePickerProps) => {
  return (
    <DatePickerContainer marginTop={Boolean(label)} width={width}>
      {label && <DatePickerLabel htmlFor={props.id}>{label}</DatePickerLabel>}
      <DatePickerInput
        type="date"
        marginTop={Boolean(label)}
        emptyValue={props.value === ''}
        {...props}
      />
    </DatePickerContainer>
  );
};
